<template>
  <div id="HugeData">
    <div id="HugeData-top"></div>
    <div id="HugeData-body">
      <p class="HugeData-body-title">国家儿童中心上海儿童医学中心</p>
      <p class="HugeData-body-content">医体结合促进儿童青少年体质健康的策略和方法</p>
      <div class="HugeData-body-graphic">
        <p class="HugeData-body-graphic-text item1">原始加速度<br>计算数据2.5T</p>
        <p class="HugeData-body-graphic-text item2">计算结果</p>
        <p class="HugeData-body-graphic-text item3">原始数据<br>初始加工</p>
        <p class="item-center">身体活动</p>
        <p class="HugeData-body-graphic-text item4">服务器集群</p>
        <p class="HugeData-body-graphic-text item5">编写计算机程序</p>
      </div>
      <p class="HugeData-body-graphic-note">(提供数据为制定中国儿童青少年身体活动指南提供了数据支撑)</p>
      <p class="HugeData-body-customer-title">客户</p>
      <p class="HugeData-body-customer-content">国家儿童中心上海儿童医学中心 | 温州医科大学附属第二医院</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#HugeData-top{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/Solution/HugeData/HugeData_Banner.png);
}
#HugeData-body{
  padding-top: 60px;
  padding-bottom: 60px;
}
#HugeData-body p{
  line-height: 22px;
}
#HugeData-body .HugeData-body-title{
  font-size: 36px;
  color: #282828;
}
#HugeData-body .HugeData-body-content{
    font-size: 16px;
    color:#909090;
    margin-top: 10px;
}
#HugeData-body .HugeData-body-graphic{
  height: 520px;
  width: 560px;
  display: inline-block;
  margin-top: 40px;
  background-repeat:no-repeat;
  background-position:center 42px;
  background-image: url(../../assets/images/Solution/HugeData/graphic.png);
}
#HugeData-body .item1{
  margin-top: 8px;
}
#HugeData-body .item2{
  float: left;
  margin-top: 138px;
}
#HugeData-body .item3{
  float: right;
  margin-top: 124px;
}
#HugeData-body .item4{
  float: left;
  margin-left: 80px;
  margin-top: 170px;
}
#HugeData-body .item5{
  float: right;
  margin-right: 46px;
  margin-top: 170px;
}
#HugeData-body .item-center{
  font-size: 36px;
  color:#282828;
  margin-top: 198px;
}
#HugeData-body .HugeData-body-graphic-text{
  font-size: 20px;
  color: #909090;
}
#HugeData-body .HugeData-body-graphic-note{
  margin-top: 16px;
  font-size: 14px;
  color: #909090;
}
#HugeData-body .HugeData-body-customer-title{
  font-size: 18px;
  margin-top: 40px;
  color: #404040;
}
#HugeData-body .HugeData-body-customer-content{
  font-size: 16px;
  margin-top: 10px;
  color: #909090;
}

</style>



// WEBPACK FOOTER //
// src/pages/Solution/HugeData.vue